/**
 * 関数名 (雛形)
 * 関数の説明
 * @param {string} el - 変数の説明が入ります
 * @param {string} value - 変数の説明が入ります
 */


/**
 * jQuery ライクな slideUp() 関数 
 * 名前の通りです。
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */



const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};


/**
 * jQuery ライクな slideDown() 関数 
 * 名前の通りです。
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */

const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};


/**
 * jQuery ライクな slideToggle() 関数 
 * 名前の通りです。上記slideUp()、slideDown() が必須です。
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */

const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
}


/**
 * スクロール制御用関数 ※iOS Safari にも対応
 * 主にモーダルWindow で利用
 * References: https://myscreate.com/optional-modal/
 * @param {string} el - 要素を指定します
 * @param {string} duration - 実行時間を指定します。デフォルト値は300
 */
function bodyScrollPrevent(flag, modal) {
  let scrollPosition;
  const body = document.getElementsByTagName('body')[0];
  const ua = window.navigator.userAgent.toLowerCase();
  const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  const scrollBarWidth = window.innerWidth - document.body.clientWidth;

  if (flag) {
    scrollPosition = -window.pageYOffset;
    body.style.position = 'fixed';
    body.style.width = '100%';
    body.style.height = '100lvh';
    body.style.top = scrollPosition + 'px';
    // console.log('bodyScrollPrevent: true')
  } else if (!flag) {
    // } else {
    addEventListenerOnce(modal, 'transitionend', function () {
      scrollPosition = parseInt(body.style.top.replace(/[^0-9]/g, ''));
      body.style.position = '';
      body.style.width = '';
      body.style.top = '';
      window.scrollTo(0, scrollPosition);
      // console.log('bodyScrollPrevent: false')
    });
  }


  function addEventListenerOnce(node, event, callback) {
    const handler = function (e) {
      callback.call(this, e);
      node.removeEventListener(event, handler);
    };
    node.addEventListener(event, handler);
  }
}
/**
 * UAParser.js の読み込み
 * 
 * How to
 * 例えばモバイルまたはタブレットデバイスで閲覧している際は、
 * console.log.(UA.getDevice().type)
 * とすると
 * mobile か tablet が返ってきます。
 */
// const UA = new UAParser()



// ページ内リンクのみ取得
var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 300,//スクロールする速さ
  header: '.l-header',
  offset: 24
});


/**
 * #burger-button をクリックしたら #is-active を付与
 * 一緒にモバイルメニューを表示するようにしました。
 * @param {string} burgerIdName - クリックされる要素のIDを記載。# は無し。
 * @param {string} menuClassName - クリックされたら表示される要素のIDを記載。# は無し。
 */

const burgerMenu = () => {
  const menuClosedIdName = 'mobile-menu-closed'
  const overlayIdName = 'mobile-overlay'

  const button = document.getElementById('burger-button')
  const menu = document.getElementById('mobile-menu')
  const menuClosed = document.getElementById(menuClosedIdName)
  const overlay = document.getElementById(overlayIdName)
  const html = document.getElementsByTagName('html')
  const body = document.getElementsByTagName('body')

  if (!button) return;

  button.addEventListener('click', () => {
    button.classList.toggle('is-active')
    menu.classList.toggle('is-visible')
    // menuClosed.classList.toggle('is-visible')
    // overlay.classList.toggle('is-visible')

    for (let i = 0; i < html.length; i++) {
      html[i].classList.toggle('u-ofy-h')
    }

    for (let i = 0; i < body.length; i++) {
      body[i].classList.toggle('u-ofy-h')
    }
  })
}

burgerMenu()


/**
 * burgerMenu() で付与された class を削除するだけの関数
 * リサイズ時にぐちゃっとならないよう768px以上からclassが消えるに修正。
 * @param {string} burgerIdName - クリックされる要素のIDを記載。# は無し。
 * @param {string} menuClassName - クリックされたら表示される要素のIDを記載。# は無し。
 */

const removeBurgerMenuClass = () => {
  const burgerIdName = 'burger-button',
    menuClassName = 'mobile-menu',
    menuClosedIdName = 'mobile-menu-closed',
    overlayClassName = 'mobile-overlay',
    button = document.getElementById(burgerIdName),
    menu = document.getElementById(menuClassName),
    menuClosed = document.getElementById(menuClosedIdName),
    overlay = document.getElementById(overlayClassName)

  if (button) {
    button.classList.remove('is-active')
    menu.classList.remove('is-visible')
    menuClosed.classList.remove('is-visible')
    overlay.classList.remove('is-visible')
  }
}

/**
 * overlay タップ時にもメニューを閉じる
 */
const closeOverlayTouchMobleMenu = () => {
  const overlayClassName = 'mobile-overlay'
  const overlay = document.getElementById(overlayClassName)

  overlay.addEventListener('click', () => {
    if (overlay) {
      removeBurgerMenuClass()
    }
  })
}

// closeOverlayTouchMobleMenu()


/**
 * モバイルメニューのアコーディオン
 */
const mobileMenuAccordion = () => {
  const target = document.querySelectorAll('.js-mobile-menu')

  function accordionToggle() {
    const content = this.nextElementSibling
    const contentHeight = content.firstElementChild.offsetHeight

    if (this.classList.contains('is-open')) {
      content.setAttribute('style', 'height: ' + contentHeight + 'px;')

      setTimeout(() => {
        content.style.height = 0
        // content.setAttribute('style', 'height: 0px;')
      }, 50);
    } else {
      content.style.height = contentHeight + 'px'
      // content.setAttribute('style', 'height: ' + contentHeight + 'px;')

      setTimeout(() => {
        content.style.height = 'auto'
        // content.setAttribute('style', 'height: auto;')
      }, 200);
    }

    content.classList.toggle('is-open')

    const target = this
    target.classList.toggle('is-open')
  }

  for (let i = 0; i < target.length; i++) {
    target[i].addEventListener('click', accordionToggle)
  }
}

mobileMenuAccordion();


/**
 * Desktop メガメニュー
 */

const megaMenu = () => {
  const menuItem = document.querySelectorAll('.js-gnav__hierarchy-exists')
  const childMenuName = '.l-gnav__child-menu'

  const openMegaMenu = (e) => {
    const child = e.currentTarget.querySelector(childMenuName)
    e.currentTarget.classList.add('is-active')

    slideDown(child, 300);
  }

  const closeMegaMenu = (e) => {
    const child = e.currentTarget.querySelector(childMenuName)
    e.currentTarget.classList.remove('is-active')

    slideUp(child, 100);
  }

  for (let i = 0; i < menuItem.length; i++) {
    menuItem[i].addEventListener('mouseenter', openMegaMenu)
    menuItem[i].addEventListener('mouseleave', closeMegaMenu)
  }
}

// megaMenu();


function toggleHeaderNavMenu() {
  const menuTriggers = document.querySelectorAll('.js-gnav__hierarchy-exists');
  const overlay = document.querySelector('.gnav-overlay');

  // 必要な要素がページになければ何もしない
  if (menuTriggers.length === 0 || !overlay) {
    return;
  }

  // 開いているメニューをすべて閉じる関数
  const closeAllMenus = () => {
    // 全てのトリガーから .is-open クラスを削除
    menuTriggers.forEach(trigger => {
      trigger.classList.remove('is-open');
    });

    // 全てのサブメニューから .is-active クラスを削除
    document.querySelectorAll('.l-gnav__child-menu').forEach(menu => {
      menu.classList.remove('is-active');
    });

    // オーバーレイを非表示に
    overlay.classList.remove('is-active');
  };

  // 各メニュートリガーにクリックイベントを設定
  menuTriggers.forEach(trigger => {
    const clickableElement = trigger.querySelector('.l-gnav__item__heading__parent');
    const childMenu = trigger.querySelector('.l-gnav__child-menu');

    if (clickableElement && childMenu) {
      clickableElement.addEventListener('click', (event) => {
        event.stopPropagation();

        // サブメニューがアクティブか
        const wasActive = childMenu.classList.contains('is-active');

        // 全てのメニューを閉じる
        closeAllMenus();

        if (!wasActive) {
          trigger.classList.add('is-open');
          childMenu.classList.add('is-active');
          overlay.classList.add('is-active');
        }
      });
    }

    // サブメニュー内でクリックしてもメニューを閉じないように
    if (childMenu) {
      childMenu.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  });

  // オーバーレイをクリックしたら全てのメニューを閉じる
  overlay.addEventListener('click', () => {
    closeAllMenus();
  });

  // Escキーでも閉じられるように
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllMenus();
    }
  });
}

toggleHeaderNavMenu();


function toggleNavMenu() {
  const toggleButtons = document.querySelectorAll('.js-gnav__toggle__button');
  const toggleChildMenu = '.l-gnav__child-menu';
  const overlay = document.querySelector('.l-gnav__item__toggle__button__overlay');

  function toggleMenu() {
    toggleButtons.forEach(menuBody => {
      menuBody.addEventListener('click', (e) => {
        if (!menuBody.classList.contains('is-active')) {
          slideDown(e.currentTarget.nextElementSibling, 300);
          e.currentTarget.classList.add('is-active')

          overlay.classList.add('is-active');
          // console.log('click');
        } else {
          slideUp(e.currentTarget.nextElementSibling, 100);
          e.currentTarget.classList.remove('is-active')
          overlay.classList.remove('is-active');
        }
      })
    })

    overlay.addEventListener('click', () => {
      const activeElm = document.querySelector('.is-active.js-gnav__toggle__button')
      slideUp(activeElm.nextElementSibling, 100);
      activeElm.classList.remove('is-active');
      overlay.classList.remove('is-active');
    })
  }

  toggleMenu()

  // 要素外をクリックで非表示
  // https://dubdesign.net/javascript/closest-floatingmenu/
}

// toggleNavMenu();


/**
 * 絞り込みモーダルを表示
 * utility.js にある bodyScrollPrevent() が必要
 */
const modalSegment = () => {
  if (document.getElementById('modalArea')) {
    const modalArea = document.getElementById('modalArea')
    const openModal = document.getElementById('openModal')
    const closeModal = document.getElementById('closeModal')
    const html = document.getElementsByTagName('html')
    const body = document.getElementsByTagName('body')
    // const modalBg = document.getElementById('modalBg')
    const toggle = [
      openModal,
      closeModal
    ]

    for (let i = 0, len = toggle.length; i < len; i++) {
      toggle[i].addEventListener('click', function () {
        // console.log(toggle[i])

        if (!modalArea.classList.contains('is-show')) {
          modalArea.classList.add('is-show')

          for (let i = 0; i < html.length; i++) {
            html[i].classList.add('u-suspend-scroll__html')
          }

          for (let i = 0; i < body.length; i++) {
            body[i].classList.add('u-suspend-scroll__body')
          }

          // スクロール制御関数
          // bodyScrollPrevent(true)
          // console.log('true')
        } else {
          modalArea.classList.remove('is-show')

          for (let i = 0; i < html.length; i++) {
            html[i].classList.remove('u-suspend-scroll__html')
          }

          for (let i = 0; i < body.length; i++) {
            body[i].classList.remove('u-suspend-scroll__body')
          }
        }
      })
    }
  }
}

modalSegment()


// Home よくある質問のアコーディオン
const faqAccordionMenu = () => {
  const target = document.querySelectorAll('.p-home__faq__block__question')

  function accordionToggle() {
    const content = this.nextElementSibling

    let contentHeight = content.firstElementChild.offsetHeight

    if (this.classList.contains('is-open')) {
      content.setAttribute('style', 'height: 0px;')
    } else {
      content.setAttribute('style', 'height: ' + contentHeight + 'px;')
    }

    content.classList.toggle('is-open')

    const target = this
    target.classList.toggle('is-open')
  }

  for (let i = 0; i < target.length; i++) {
    target[i].addEventListener('click', accordionToggle)
  }
}

faqAccordionMenu()


// Products 商品説明アコーディオン
const productsAccordion = () => {
  if (document.querySelector('.c-products__accordion__label')) {
    const target = document.querySelectorAll('.c-products__accordion__label');
    // const closeButton = document.querySelector('.c-products__accordion__label__close__button');

    function accordionToggle() {
      const content = this.nextElementSibling;

      let contentHeight = content.firstElementChild.offsetHeight;

      if (this.classList.contains('is-open')) {
        content.setAttribute('style', 'height: 0px;');
      } else {
        content.setAttribute('style', 'height: ' + contentHeight + 'px;');
      }

      content.classList.toggle('is-open');

      const target = this;
      target.classList.toggle('is-open');
    }

    for (let i = 0; i < target.length; i++) {
      target[i].addEventListener('click', accordionToggle);
    }
  }
}

productsAccordion();


// Products 外観ランクアコーディオン
const rankAccordion = () => {
  const target = document.querySelectorAll('.e-rank__accordion__label')

  function accordionToggle() {
    const content = this.nextElementSibling

    let contentHeight = content.firstElementChild.offsetHeight

    if (this.classList.contains('is-open')) {
      content.setAttribute('style', 'height: 0px;')
    } else {
      content.setAttribute('style', 'height: ' + contentHeight + 'px;')
    }

    content.classList.toggle('is-open')

    const target = this
    target.classList.toggle('is-open')
  }

  for (let i = 0; i < target.length; i++) {
    target[i].addEventListener('click', accordionToggle)
  }
}

rankAccordion();


// Products ご注意事項アコーディオン
const attentionAccordion = () => {
  const target = document.querySelectorAll('.e-products__link')

  function accordionToggle() {
    const parentElem = this.parentElement;
    const content = parentElem.previousElementSibling

    let contentHeight = content.firstElementChild.offsetHeight

    if (this.classList.contains('is-open')) {
      content.setAttribute('style', 'height: 0px;')
    } else {
      content.setAttribute('style', 'height: ' + contentHeight + 'px;')
    }

    content.classList.toggle('is-open')

    const target = this
    target.classList.toggle('is-open')
  }

  for (let i = 0; i < target.length; i++) {
    target[i].addEventListener('click', accordionToggle)
  }
}

attentionAccordion();


// Column PageTop ボタン
const initPageTopButton = () => {
  const pageTopBtn = document.getElementById('pageTopBtn');

  // ボタンが存在しない場合は処理を終了
  if (!pageTopBtn) return;

  // スクロール位置監視
  const handleScroll = () => {
    if (window.scrollY > 300) {
      pageTopBtn.classList.add('is-visible');
    } else {
      pageTopBtn.classList.remove('is-visible');
    }
  };

  // トップへスクロール
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // イベントリスナーの設定
  window.addEventListener('scroll', handleScroll);
  pageTopBtn.addEventListener('click', scrollToTop);
}

initPageTopButton();


/**
 * ブログ記事サイドバーのアコーディオン
 */
const articleSidebarAccordion = () => {
  const target = document.querySelectorAll('.js-article__sidebar__accordion');

  function accordionToggle() {
    const content = this.nextElementSibling;
    const contentHeight = content.firstElementChild.offsetHeight;

    if (this.classList.contains('is-open')) {
      content.setAttribute('style', 'height: ' + contentHeight + 'px;');

      setTimeout(() => {
        content.style.height = 0;
      }, 50);
    } else {
      content.style.height = contentHeight + 'px';

      setTimeout(() => {
        content.style.height = 'auto';
      }, 200);
    }

    content.classList.toggle('is-open');

    const target = this
    target.classList.toggle('is-open');
  }

  for (let i = 0; i < target.length; i++) {
    target[i].addEventListener('click', accordionToggle);
  }
}

articleSidebarAccordion();


/**
 * スクロールに応じたヘッダーの表示・非表示
 */
function headerInteraction() {
  const headerInner = document.querySelector('.l-n-header__inner');
  if (!headerInner) return;

  const headerHeight = headerInner.offsetHeight;

  let lastScrollPosition = 0;
  let ticking = false;
  // ヘッダーが一度でも表示されたかを記憶するフラグ
  let headerHasBeenVisible = false;

  const updateHeader = () => {
    const currentScrollPosition = window.scrollY;

    // スクロールが最上部に戻ったら、フラグをリセットして次の動作に備える
    if (currentScrollPosition === 0) {
      headerHasBeenVisible = false;
    }

    // --- モード1：Sticky挙動モード（ページ上部） ---
    if (currentScrollPosition <= headerHeight) {
      // 一度も表示されていなければ（＝初回の下スクロール）、Sticky挙動を実行
      if (!headerHasBeenVisible) {
        headerInner.style.transform = `translateY(-${currentScrollPosition}px)`;
        headerInner.style.transition = 'none';
        headerInner.classList.remove('is-hidden');
      }
      // 一度表示された後なら、表示されたままにする
      else {
        headerInner.style.transform = '';
        headerInner.style.transition = '';
        headerInner.classList.remove('is-hidden');
      }
    }
    // --- モード2：表示・非表示モード（スクロール後） ---
    else {
      headerInner.style.transform = '';
      headerInner.style.transition = '';

      // 上にスクロールした場合
      if (currentScrollPosition < lastScrollPosition) {
        headerInner.classList.remove('is-hidden');
        // ヘッダーが表示されたことを記憶
        headerHasBeenVisible = true;
      }
      // 下にスクロールした場合
      else {
        headerInner.classList.add('is-hidden');
      }
    }

    lastScrollPosition = currentScrollPosition;
    ticking = false;
  };

  // スクロールイベントを監視
  document.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });
}

headerInteraction();


/**
 * ヘッダーの高さのCSS変数を設定し、リサイズ時も追従するように設定する関数
 */
function setupHeaderHeightUpdater() {
  // ■■■ 実際の処理を行う内部関数 ■■■
  function setHeaderHeightProperty() {
    const headerInner = document.querySelector('.l-n-header__inner');
    if (!headerInner) return;

    const headerHeight = headerInner.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }

  // イベントリスナーの設定
  let isResizeTicking = false;

  window.addEventListener('resize', () => {
    if (!isResizeTicking) {
      window.requestAnimationFrame(() => {
        setHeaderHeightProperty();
        isResizeTicking = false;
      });
      isResizeTicking = true;
    }
  });

  // 初回実行
  // 最初に一度だけ実行して初期値を設定
  setHeaderHeightProperty();
}

setupHeaderHeightUpdater();


function productBatteryMore() {
  const triggers = document.querySelectorAll('.c-products__battery__trigger');

  /**
   * デバウンス関数：処理が連続で呼び出された場合、最後の呼び出しから指定時間後に一度だけ実行する
   * @param {Function} func - 実行する関数
   * @param {number} delay - 遅延させる時間 (ミリ秒)
   */
  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  /**
   * 開いているアコーディオンの高さを再計算する関数
   */
  function updateOpenAccordionHeight() {
    // is-openクラスを持つ (=開いている) コンテンツ要素を取得
    const openContent = document.querySelector('.c-products__battery__inner.is-open');

    // 開いている要素があれば高さを再設定
    if (openContent) {
      // 一度高さをリセットしてから再計算することで、縮んだ場合にも対応
      openContent.style.maxHeight = null;
      openContent.style.maxHeight = openContent.scrollHeight + 'px';
    }
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      const contentId = trigger.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      if (!content) {
        return;
      }

      trigger.classList.toggle('is-open');
      content.classList.toggle('is-open'); // is-openクラスは高さの再計算に利用

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !isExpanded);

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      // ラベルはトリガーの data 属性 (Liquid 側で翻訳済) を優先。属性が無ければ日本語にフォールバック
      const openLabel = trigger.dataset.labelOpen || '詳しくはこちら';
      const closeLabel = trigger.dataset.labelClose || '閉じる';
      if (trigger.classList.contains('is-open')) {
        trigger.textContent = closeLabel;
      } else {
        trigger.textContent = openLabel;
      }
    });
  });

  // デバウンス処理を適用したリサイズ用の関数を作成 (250ms)
  const debouncedResize = debounce(updateOpenAccordionHeight, 250);

  // ウィンドウのリサイズイベントに、デバウンスを適用した関数を登録
  window.addEventListener('resize', debouncedResize);
}

productBatteryMore();


function carouselProduct() {
  const classname = '.c-carousel__product';
  const carousels = document.querySelectorAll(classname);

  if (carousels.length > 0) {
    for (let i = 0; i < carousels.length; i++) {
      const carousel = carousels[i];

      // data属性から設定値を取得（文字列'true'を真偽値trueに変換）
      const isNavigation = carousel.dataset.isNavigation === 'true';
      const isPagination = carousel.dataset.isPagination === 'true';

      const options = {
        mediaQuery: 'min',
        type: 'slide',
        destroy: true,
        // ここで動的にオプションを設定
        arrows: isNavigation,
        pagination: isPagination,
        breakpoints: {
          768: {
            destroy: false,
            perPage: 5,
            perMove: 5,
            gap: '16px',
          }
        },
        classes: {
          arrows: 'c-carousel__product__arrows splide__arrows',
          arrow: 'c-carousel__product__arrow splide__arrow',
          pagination: 'c-carousel__product__pagination splide__pagination',
          page: 'c-carousel__product__page splide__pagination__page',
        },
      }

      new Splide(carousel, options).mount();
    }
  }
}

carouselProduct();


/**
 * バリエーションの変更を監視して今すぐ購入ボタンのリンクを更新する
 */
function initializeBuyNowButton() {
  // バリエーションを選択する要素を取得
  const variantSelector = document.querySelector('form[action="/cart/add"] [name="id"]');

  // 今すぐ購入ボタンのリンク要素を取得
  const buyNowLink = document.getElementById('buy-now-link');

  // 必要な要素がページ内に存在する場合のみ処理を実行
  if (!variantSelector || !buyNowLink) {
    // 要素が見つからない場合は何もしない
    return;
  }

  // バリエーションセレクターの値が変更されたときの処理
  variantSelector.addEventListener('change', function () {
    // 選択されたバリエーションの ID を取得
    const selectedVariantId = this.value;

    // 今すぐ購入ボタンのリンクを新しいバリエーション ID で更新
    buyNowLink.href = `/cart/${selectedVariantId}:1`;
  });
}

initializeBuyNowButton();


/**
 * URLのクエリパラメータ 'product' の値を取得して
 * クラス名が '.product-name' のinput要素にその値を設定
 * 該当の input 要素が存在しない場合は何もせずに処理を終了
 */
function autoFillProductNameFromURL() {
  // URLからクエリパラメータを取得
  const params = new URLSearchParams(window.location.search);
  const productName = params.get('product');

  // 'product' パラメータが存在するかチェック
  if (!productName) {
    return;
  }

  // '.product-name' のクラスを持つ input 要素を探す
  const productInput = document.querySelector('input.product-name');

  // input要素が存在する場合のみ値を設定
  if (productInput) {
    productInput.value = productName;
  }
}

autoFillProductNameFromURL();


function carouselSideview() {
  const classname = '.c-carousel__sideview';
  const carousels = document.querySelectorAll(classname);

  if (carousels.length > 0) {
    for (let i = 0; i < carousels.length; i++) {
      const carousel = carousels[i];
      const slides = carousel.querySelectorAll('.splide__slide');

      // data属性から基本設定を読み込む
      let isNavigation = carousel.dataset.isNavigation === 'true';
      let isPagination = carousel.dataset.isPagination === 'true';
      let sliderType = 'loop';

      // スライドが1枚以下の場合はオプションを上書き
      if (slides.length <= 1) {
        isNavigation = false; // ナビゲーション矢印を無効化
        isPagination = false; // ページネーションを無効化
        sliderType = 'slide';   // ループを無効化 (1枚だとエラーになるため)
      }

      const options = {
        mediaQuery: 'min',
        type: sliderType,
        destroy: true,
        arrows: isNavigation,
        pagination: isPagination,
        breakpoints: {
          768: {
            destroy: false,
            perPage: 1,
            perMove: 1,
            focus: 'center',
            padding: '40px',
          }
        },
        classes: {
          arrows: 'c-carousel__sideview__arrows splide__arrows',
          arrow: 'c-carousel__sideview__arrow splide__arrow',
          pagination: 'c-carousel__sideview__pagination splide__pagination',
          page: 'c-carousel__sideview__page splide__pagination__page',
        },
      }

      new Splide(carousel, options).mount();
    }
  }
}
carouselSideview();


/**
 * モーダル (複数適用可能)
 * openComponentModal(), closeComponentModal(), componentModals() がセット
 */

/**
 * モーダルの実行
 */
function componentModals() {
  // 開くボタンのイベント
  document.querySelectorAll('.js-modal-open').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetModalId = trigger.dataset.modalTarget;
      const targetModal = document.getElementById(targetModalId);
      // modal 要素を body の末尾に移動 (header の z-index 対策)
      document.body.appendChild(targetModal);
      openComponentModal(targetModal); // 開く関数を呼び出す
    });
  });

  // 閉じるボタン
  document.querySelectorAll('.js-modal-close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetModal = trigger.closest('.c-modal');
      closeComponentModal(targetModal);
    });
  });
};

/**
 * 指定されたモーダルを開く関数
 * @param {HTMLElement} modal - 対象のモーダル要素
 */
function openComponentModal(modal) {
  if (modal) {
    modal.classList.add('is-open');
  }
};

/**
 * 指定されたモーダルを閉じる関数
 * @param {HTMLElement} modal - 対象のモーダル要素
 */
function closeComponentModal(modal) {
  if (modal) {
    modal.classList.remove('is-open');
  }
};

componentModals();


/**
 * dialog を使ったモーダル
 */
function componentDialogs() {
  // 開くボタン
  document.querySelectorAll('.js-modal-open').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetModalId = trigger.dataset.modalTarget;
      const targetModal = document.getElementById(targetModalId);
      openComponentDialog(targetModal);
    });
  });

  // 閉じるボタン
  document.querySelectorAll('.js-modal-close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetModal = trigger.closest('dialog');
      closeComponentDialog(targetModal);
    });
  });

  // 背景クリックで閉じる
  document.querySelectorAll('.c-modal').forEach(dialog => {
    dialog.addEventListener('click', (e) => {
      // dialog 自身がクリックされた場合のみ閉じる
      if (e.target === dialog) {
        closeComponentDialog(dialog);
      }
    });
  });
};

/**
 * 指定されたダイアログを開く関数
 * @param {HTMLDialogElement} dialog - 対象のダイアログ要素
 */
function openComponentDialog(dialog) {
  if (dialog) {
    dialog.showModal();
  }
};

/**
 * 指定されたダイアログを閉じる関数
 * @param {HTMLDialogElement} dialog - 対象のダイアログ要素
 */
function closeComponentDialog(dialog) {
  if (dialog) {
    dialog.close();
  }
};

// componentDialogs();


/**
 * 商品バリアントと連動して説明カードの表示を切り替える関数
 * @param {Array} productVariants - 商品のバリアント情報の配列
 * @param {Array} productOptions - 商品のオプション名の配列 (例: ['カラー', '状態'])
 * @param {object} options - 設定オブジェクト
 */
function initializeVariantConditionCards(productVariants, productOptions, options) {
  // --- デフォルト設定 ---
  const settings = {
    optionName: '状態',
    variantSelector: 'form[action="/cart/add"] [name="id"]',
    cardsContainerSelector: '.js-condition-cards-container',
    activeClass: 'is-active',
    ...options
  };

  // --- グローバル変数から受け取ったデータをチェック ---
  if (!productVariants || !productOptions || productVariants.length === 0) {
    console.error('バリアント情報が正しく渡されていません。');
    return;
  }

  const variantSelect = document.querySelector(settings.variantSelector);
  const cardsContainer = document.querySelector(settings.cardsContainerSelector);

  if (!variantSelect || !cardsContainer) {
    return; // 必要なHTML要素がなければ何もしない
  }

  const allCards = cardsContainer.querySelectorAll('[data-condition-card]');

  // 「状態」オプションが何番目にあるかを事前に特定
  const conditionOptionIndex = productOptions.findIndex(opt => opt === settings.optionName);
  if (conditionOptionIndex === -1) {
    console.warn(`オプション名「${settings.optionName}」が見つかりませんでした。`);
    return;
  }

  const updateVisibleCard = () => {
    const currentVariantId = parseInt(variantSelect.value, 10);
    // 渡されたバリアント配列から現在のバリアントを検索
    const currentVariant = productVariants.find(v => v.id === currentVariantId);

    if (!currentVariant) return;

    // 事前に特定したインデックスを使って、現在のバリアントから「状態」の値を取得
    const selectedCondition = currentVariant.options[conditionOptionIndex];

    allCards.forEach(card => {
      if (card.dataset.conditionCard === selectedCondition) {
        card.classList.add(settings.activeClass);
      } else {
        card.classList.remove(settings.activeClass);
      }
    });
  };

  variantSelect.addEventListener('change', updateVisibleCard);
  updateVisibleCard();
}

if (window.productVariants && window.productOptions) {
  initializeVariantConditionCards(window.productVariants, window.productOptions, {
    optionName: '状態'
  });
}


/**
 * 'a.js-button' の要素を 'div.p-article__link__button' で囲む
 * .newtab クラスまたは target="_blank" があれば、新タブで開く属性を付与
 */
function wrapButtonLinks() {
  const linksToWrap = document.querySelectorAll('a.js-button');

  if (linksToWrap.length === 0) {
    return;
  }

  linksToWrap.forEach(link => {
    // .newtabクラスを持つ、または target="_blank" が存在する場合
    if (link.classList.contains('newtab') || link.target === '_blank') {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }

    const wrapperDiv = document.createElement('div');
    wrapperDiv.className = 'p-article__link__button';

    link.before(wrapperDiv);
    wrapperDiv.appendChild(link);
  });
}

wrapButtonLinks();


/**
 * シェアボタンのリンクを設定
 */
function setupShareButtons() {
  // 現在のページのタイトルと URL を取得
  const pageTitle = document.title;
  const pageUrl = location.href;

  // URL エンコード
  const encodedTitle = encodeURIComponent(pageTitle);
  const encodedUrl = encodeURIComponent(pageUrl);

  // 各シェアボタンの要素を全て取得
  const xButtons = document.querySelectorAll('.js-share-x');
  const lineButtons = document.querySelectorAll('.js-share-line');
  const facebookButtons = document.querySelectorAll('.js-share-facebook');

  // X (Twitter)
  const xShareUrl = `https://x.com/intent/post?text=${encodedTitle}&url=${encodedUrl}`;
  xButtons.forEach(button => {
    button.href = xShareUrl;
  });

  // LINE
  const lineShareUrl = `https://social-plugins.line.me/lineit/share?url=${encodedUrl}`;
  lineButtons.forEach(button => {
    button.href = lineShareUrl;
  });

  // Facebook
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  facebookButtons.forEach(button => {
    button.href = facebookShareUrl;
  });
}

// ページ読み込み時（または適切なタイミング）で実行
setupShareButtons();


/**
 * 現在のページのURLをクリップボードにコピー
 * @param {Event} event - クリックイベントオブジェクト
 */
async function copyCurrentUrl(event) {
  const button = event.currentTarget;

  // 既にクラスが付与されている場合は多重実行を防ぐ
  if (button.classList.contains('is-copied') || button.classList.contains('is-copy-failed')) {
    return;
  }

  try {
    // 現在のページ URL を取得
    const url = window.location.href;
    // クリップボードに URL を書き込む
    await navigator.clipboard.writeText(url);

    // 成功時 (クラスを付与)
    // console.log('URLがコピーされました:', url);
    button.classList.add('is-copied');

    // 2秒後にクラスを削除
    setTimeout(() => {
      button.classList.remove('is-copied');
    }, 2000);

  } catch (err) {
    // 失敗時 (クラスを付与)
    // console.error('URLのコピーに失敗しました:', err);
    button.classList.add('is-copy-failed');

    // 2秒後にクラスを削除
    setTimeout(() => {
      button.classList.remove('is-copy-failed');
    }, 2000);
  }
}

/**
 * 対象クラスを持つボタンにイベントを設定
 */
function eventCopyCurrentUrl() {
  // 'js-copy-url-button' というクラス名を持つすべての要素を取得
  const copyButtons = document.querySelectorAll('.js-copy-url-button');

  // 取得したすべてのボタンに対して...
  copyButtons.forEach(button => {
    // クリックされたら copyCurrentUrl 関数を実行するように設定
    button.addEventListener('click', copyCurrentUrl);
  });
}

eventCopyCurrentUrl();


function carouselHero() {
  const classname = '.c-carousel__hero';
  const carousels = document.querySelectorAll(classname);

  if (carousels.length > 0) {
    for (let i = 0; i < carousels.length; i++) {
      const carousel = carousels[i];
      const dataset = carousel.dataset;

      // 設定値の取得
      const breakpoint = parseInt(dataset.breakpoint, 10);

      // 文字列の 'true' を真偽値に変換
      const isNavigationMobile = dataset.isNavigationMobile === 'true';
      const isPaginationMobile = dataset.isPaginationMobile === 'true';
      const isNavigationDesktop = dataset.isNavigationDesktop === 'true';
      const isPaginationDesktop = dataset.isPaginationDesktop === 'true';
      const isAutoplay = dataset.isAutoplay === 'true';

      const autoplayInterval = parseInt(dataset.autoplayInterval, 10);

      const hasNavigation = isNavigationMobile || isNavigationDesktop;


      // 基本オプション ※モバイル設定 (mediaQuery: 'min') がベース
      const options = {
        mediaQuery: 'min',
        type: 'loop',
        focus: 'center',
        arrows: hasNavigation,
        autoplay: isAutoplay,
        interval: autoplayInterval,
        lazyLoad: 'nearby',
        pagination: isPaginationMobile, // モバイルでのドット有無
        classes: {
          arrows: 'c-carousel__hero__arrows splide__arrows',
          arrow: 'c-carousel__hero__arrow splide__arrow',
          pagination: 'c-carousel__hero__pagination splide__pagination',
          page: 'c-carousel__hero__page splide__pagination__page',
        },
      };

      // ブレイクポイントが 0 より大きい場合のみ breakpoints オプションを追加
      if (breakpoint > 0) {
        options.breakpoints = {
          [breakpoint]: {
            perPage: 1,
            perMove: 1,
            arrows: isNavigationDesktop,
            pagination: isPaginationDesktop,
          }
        };
      }

      new Splide(carousel, options).mount();
    }
  }
}

carouselHero();


function carouselMedia() {
  const classname = '.c-carousel__media';
  const carousels = document.querySelectorAll(classname);

  if (carousels.length > 0) {
    for (let i = 0; i < carousels.length; i++) {
      const carousel = carousels[i];
      const dataset = carousel.dataset;

      // 設定値の取得
      const breakpoint = parseInt(dataset.breakpoint, 10);

      // 文字列の 'true' を真偽値に変換
      const isNavigationMobile = dataset.isNavigationMobile === 'true';
      const isPaginationMobile = dataset.isPaginationMobile === 'true';
      const isNavigationDesktop = dataset.isNavigationDesktop === 'true';
      const isPaginationDesktop = dataset.isPaginationDesktop === 'true';
      const isAutoplay = dataset.isAutoplay === 'true';

      const autoplayInterval = parseInt(dataset.autoplayInterval, 10);

      const hasNavigation = isNavigationMobile || isNavigationDesktop;


      // 基本オプション ※モバイル設定 (mediaQuery: 'min') がベース
      const options = {
        mediaQuery: 'min',
        type: 'slide',
        // focus: 'center',
        destroy: true,
        arrows: hasNavigation,
        autoplay: isAutoplay,
        interval: autoplayInterval,
        lazyLoad: 'nearby',
        pagination: isPaginationMobile, // モバイルでのドット有無
        classes: {
          arrows: 'c-carousel__media__arrows splide__arrows',
          arrow: 'c-carousel__media__arrow splide__arrow',
          pagination: 'c-carousel__media__pagination splide__pagination',
          page: 'c-carousel__media__page splide__pagination__page',
        },
      };

      // ブレイクポイントが 0 より大きい場合のみ breakpoints オプションを追加
      if (breakpoint > 0) {
        options.breakpoints = {
          [breakpoint]: {
            destroy: false,
            perPage: 3,
            perMove: 3,
            arrows: isNavigationDesktop,
            pagination: isPaginationDesktop,
          }
        };
      }

      new Splide(carousel, options).mount();

      console.log('メディア！');
    }
  }
}

carouselMedia();


function productCarousel() {
  const mainElement = '.p-product__carousel__main';
  const thumbnailElement = '.p-product__carousel__thumbnail';
  const slideContents = document.querySelectorAll(mainElement + ' .splide__slide');
  const slideLength = slideContents.length;

  if (!document.querySelector(mainElement)) return;

  const carouselMain = new Splide(mainElement, {
    mediaQuery: 'min',
    type: 'slide',
    rewind: true,
    pagination: false,
    arrows: false,
    // fixedHeight: '56vw',
    lazyLoad: 'nearby',
    destroy: slideLength > 1 ? false : 'completely',
    gap: 32,
    classes: {
      arrows: 'p-product__carousel__main__arrows splide__arrows',
      arrow: 'p-product__carousel__main__arrow splide__arrow',
      pagination: 'p-product__carousel__main__pagination splide__pagination',
      page: 'p-product__carousel__main__page splide__pagination__page',
    },
  });

  const carouselThumbnail = new Splide(thumbnailElement, {
    mediaQuery: 'min',
    type: 'slide',
    speed: 200,  // スライダーが切り替わる際のアニメーション時間
    // autoplay: true,  // 自動再生を有効化するか default: false
    // interval: 1000,  // autoplay 有効化時、次のスライダーまでの待機時間
    rewind: true,  // fade で autoplay: true する場合は rewind: true 必須
    perPage: 2,
    perMove: 1,
    // pauseOnHover: false,  // マウスオーバーした際に autoplay を止めるか default: true
    // arrows: false,
    lazyLoad: 'nearby',
    isNavigation: true,
    pagination: false,
    gap: 4,
    // cover: true,
    // fixedHeight: 'auto',
    // heightRatio: 1,
    // fixedWidth: 100,
    // fixedHeight: 100,
    destroy: slideLength > 1 ? false : 'completely',
    breakpoints: {
      768: {
        perPage: 5,
        // perMove: 5,
        gap: 12,
        // heightRatio: 0,
      }
    },
    breakpoints: {
      992: {
        perPage: 5,
        // perMove: 5,
        gap: 12,
        // heightRatio: 0,
      }
    },
    classes: {
      arrows: 'p-product__carousel__thumbnail__arrows splide__arrows',
      arrow: 'p-product__carousel__thumbnail__arrow splide__arrow',
      pagination: 'p-product__carousel__thumbnail__pagination splide__pagination',
      page: 'p-product__carousel__thumbnail__page splide__pagination__page',
    },
  });

  carouselMain.sync(carouselThumbnail);
  carouselMain.mount();
  carouselThumbnail.mount();

  // メイン画像を GLightbox で拡大表示
  // 複数枚あれば拡大後に前後ナビゲーション（ページネーション）が自動で有効になる
  const zoomImages = document.querySelectorAll(mainElement + ' .p-product__carousel__main__zoom');
  if (zoomImages.length > 0) {
    let lightbox = null;

    // クリック時に遅延初期化する（GLightbox の読み込みタイミングに依存しない）
    const buildLightbox = () => {
      if (lightbox) return lightbox;
      if (typeof GLightbox !== 'function') {
        console.warn('[product-carousel] GLightbox が読み込まれていません。glightbox の JS/CSS が読み込まれているか確認してください。');
        return null;
      }
      const elements = Array.from(zoomImages).map((img) => ({
        // 拡大表示には高解像度版（data-zoom-src）を使う。
        // Splide の lazyLoad で img.src が未読込でも data 属性なら確実に取得できる
        href: img.dataset.zoomSrc || img.currentSrc || img.src,
        type: 'image',
        alt: img.dataset.zoomAlt || img.alt || '',
      }));
      lightbox = GLightbox({
        elements: elements,
        touchNavigation: true,
        loop: zoomImages.length > 1,
        zoomable: true,
      });

      // モバイル（body に glightbox-mobile クラスが付く）では、GLightbox は
      // 外側タップで閉じる挙動を無効化している。そこで独自にタップ判定を追加し、
      // 画像・操作ボタン以外をタップしたら閉じるようにする（スワイプは除外）。
      lightbox.on('open', () => {
        const container = document.querySelector('.glightbox-container');
        if (!container || container.dataset.outsideTapBound) return;
        container.dataset.outsideTapBound = '1';

        const TAP_THRESHOLD = 10; // この移動量(px)未満をタップとみなす
        let startX = 0;
        let startY = 0;
        let moved = false;

        const isImageOrControl = (target) => {
          if (!target || !target.closest) return false;
          // 画像本体（ピンチズーム等を妨げない）と各操作ボタンは閉じない
          return !!target.closest('.gslide-media, .gbtn, .gnext, .gprev, .gclose');
        };

        container.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) { moved = true; return; } // ピンチ等は除外
          moved = false;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });

        container.addEventListener('touchmove', (event) => {
          if (!event.touches.length) return;
          if (Math.abs(event.touches[0].clientX - startX) > TAP_THRESHOLD ||
            Math.abs(event.touches[0].clientY - startY) > TAP_THRESHOLD) {
            moved = true; // スワイプ（画像送り）とみなす
          }
        }, { passive: true });

        container.addEventListener('touchend', (event) => {
          if (moved) return;
          if (isImageOrControl(event.target)) return;
          lightbox.close();
        });
      });

      return lightbox;
    };

    zoomImages.forEach((img, index) => {
      img.addEventListener('click', (event) => {
        event.preventDefault();
        const lb = buildLightbox();
        if (lb) lb.openAt(index);
      });
    });
  }
}

productCarousel();


/**
 * アコーディオン
 */
function detailAccordion() {
  const containerSelector = '.js-accordion';          // 全体を囲むコンテナ
  const detailsSelector = '.js-accordion__details';   // details タグ
  const summarySelector = '.js-accordion__summary';   // summary タグ
  const contentSelector = '.js-accordion__content';   // アニメーションさせる中身のラッパー
  const closeButtonSelector = '.js-accordion__close'; // 閉じるボタン

  const containers = document.querySelectorAll(containerSelector);

  containers.forEach(container => {
    const isExclusive = container.dataset.exclusive === 'true';
    const duration = container.dataset.duration ? parseInt(container.dataset.duration) : 200;

    const animOptions = {
      duration: duration,
      easing: 'ease-in-out'
    };

    const allDetails = container.querySelectorAll(detailsSelector);

    const openDetails = (details) => {
      if (details.open) return;

      details.open = true;
      const content = details.querySelector(contentSelector);

      if (content) {
        const endHeight = content.offsetHeight;

        content.animate(
          { height: ['0px', endHeight + 'px'] },
          animOptions
        );
      }
    };

    const closeDetails = (details) => {
      if (!details.open) return;

      const content = details.querySelector(contentSelector);

      if (content) {
        const animation = content.animate(
          { height: [content.offsetHeight + 'px', '0px'] },
          animOptions
        );

        animation.onfinish = () => {
          details.open = false;
        };
      } else {
        details.open = false;
      }
    };

    allDetails.forEach(details => {
      const summary = details.querySelector(summarySelector);
      const closeButton = details.querySelector(closeButtonSelector);

      if (summary) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();

          if (details.open) {
            closeDetails(details);
          } else {
            if (isExclusive) {
              allDetails.forEach(other => {
                if (other !== details && other.open) {
                  closeDetails(other);
                }
              });
            }
            openDetails(details);
          }
        });
      }

      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          closeDetails(details);
        });
      }
    });
  });
}

detailAccordion();


/**
 * タブメニュー
 */
function tabMenu() {
  if (document.querySelector('.js-tab')) {
    const tabMenus = document.querySelectorAll('.js-tab__list');
    const tabPanels = document.querySelectorAll('.js-tab__content__panel');
    const addClassname = 'is-active';

    tabMenus.forEach((tabMenu) => {
      tabMenu.addEventListener('click', () => {
        tabMenus.forEach((t) => {
          t.classList.remove(addClassname);
        });

        tabPanels.forEach((tabPanel) => {
          tabPanel.classList.remove(addClassname);
        });

        tabMenu.classList.add(addClassname);

        const tabIndex = Array.from(tabMenus).indexOf(tabMenu);
        tabPanels[tabIndex].classList.add(addClassname);
      });
    });
  }
};

tabMenu();

/**
 * タブメニュー (トグル付き)
 */
function tabMenuToggle() {
  const tabContainer = document.querySelector('.c-collection__facets__nav');

  if (tabContainer) {
    const tabMenus = document.querySelectorAll('.js-tabmenu__toggle__list');
    const tabPanels = document.querySelectorAll('.js-tabmenu__toggle__panel');
    const addClassname = 'is-active';

    tabMenus.forEach((tabMenu, index) => {
      tabMenu.addEventListener('click', () => {
        const isActive = tabMenu.classList.contains(addClassname);

        tabMenus.forEach(t => t.classList.remove(addClassname));
        tabPanels.forEach(p => p.classList.remove(addClassname));

        if (!isActive) {
          tabMenu.classList.add(addClassname);
          tabPanels[index].classList.add(addClassname);
        }
      });
    });
  }
}

tabMenuToggle();

/**
 * Judge.me ウィジェットの調整
 * 1. レビュー日付のフォーマット変換：アプリ設定に YYYY/MM/DD が無いため、
 *    描画後の MM/DD/YYYY を YYYY/MM/DD に書き換える（冪等：YYYY/MM/DD は 4桁始まりのため再マッチしない）。
 * 2. 「レビューの収集方法は？」リンクの差し替え：外部ページへのリンクを
 *    自サイトの /pages/review-authenticity に向ける。
 * レビューは非同期＆ページネーションで読み込まれるため MutationObserver で監視する。
 */
function adjustJudgemeWidget() {
  const datePattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  const authenticityUrl = '/pages/review-authenticity';

  const convert = (root) => {
    // 日付フォーマット変換
    root.querySelectorAll('.jdgm-rev__timestamp').forEach((el) => {
      const match = el.textContent.trim().match(datePattern);
      if (match) {
        el.textContent = `${match[3]}/${match[1].padStart(2, '0')}/${match[2].padStart(2, '0')}`;
      }
    });

    // 「レビューの収集方法は？」リンクの差し替え
    // 旧ウィジェットはテキスト一致、新ウィジェット(レビュー記入フォーム)は .jm-review-collection-link で判定
    const links = root.matches('a') ? [root] : [];
    links.push(...root.querySelectorAll('a'));
    links.forEach((link) => {
      if (link.dataset.authenticityRewritten) return;
      if (link.classList.contains('jm-review-collection-link') || link.textContent.includes('収集方法')) {
        link.href = authenticityUrl;
        link.textContent = 'レビューの信頼性について';
        link.removeAttribute('target');
        link.removeAttribute('rel');
        link.dataset.authenticityRewritten = 'true';
      }
    });
  };

  convert(document.body);

  // 新ウィジェットは .jdgm-rev-widget の外に描画されるため body 全体を監視する
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) convert(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

adjustJudgemeWidget();


/**
 * 商品ページ: 1つ目の商品タイトルが下スクロールでビューポートから消えたら、
 * .l-n-header__inner の直後に複製した見出しを固定表示し続ける
 */
function setupProductStickyTitle() {
  const headerInner = document.querySelector('.l-n-header__inner');
  if (!headerInner) return;

  // テンプレート・ブレイクポイント差異を吸収して1つ目の見出し候補を集める
  const candidates = Array.from(
    document.querySelectorAll('.p-product__title--mobile, .p-product__title--top, .c-products__ttl__name')
  );
  if (candidates.length === 0) return;

  // 現在レンダリングされている (display: none でない) 最初の見出し
  const getVisibleTitle = () => candidates.find((el) => el.getClientRects().length > 0);

  const initialTitle = getVisibleTitle() || candidates[0];

  // 複製見出しを .l-n-header__inner の直後に配置
  // data-product-title があればそちらを優先（型番付加・ランク除外をしていない素の product.title）
  const stickyTitle = document.createElement('div');
  stickyTitle.className = 'p-product__sticky-title';
  stickyTitle.textContent = initialTitle.dataset.productTitle || (initialTitle.textContent || '').trim();
  stickyTitle.setAttribute('aria-hidden', 'true');
  headerInner.insertAdjacentElement('afterend', stickyTitle);

  // ヘッダーが is-hidden で隠れたら複製見出しを最上部 (top: 0) に追従させる
  const syncHeaderState = () => {
    stickyTitle.classList.toggle('is-header-hidden', headerInner.classList.contains('is-hidden'));
  };
  new MutationObserver(syncHeaderState).observe(headerInner, { attributes: true, attributeFilter: ['class'] });
  syncHeaderState();

  // 1つ目の見出しが画面上方向に消えたら表示、再び見えたら非表示
  const observer = new IntersectionObserver((entries) => {
    const currentTitle = getVisibleTitle();
    entries.forEach((entry) => {
      if (entry.target !== currentTitle) return;
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyTitle.classList.toggle('is-visible', scrolledPast);
    });
  });
  candidates.forEach((el) => observer.observe(el));
}

setupProductStickyTitle();
